import { render, staticRenderFns } from "./Kaffeenew.vue?vue&type=template&id=0c9a2253&scoped=true"
import script from "./Kaffeenew.vue?vue&type=script&lang=js"
export * from "./Kaffeenew.vue?vue&type=script&lang=js"
import style0 from "./Kaffeenew.vue?vue&type=style&index=0&id=0c9a2253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a2253",
  null
  
)

export default component.exports